import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { School } from '../../../../../../models/school';
import '../SchoolEvents.scss';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection
} from '../SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  school: School;
}

// report 021
export function DateFixturesReport({ onCloseClick, onSubmit, school }: Props) {
  const now = new Date();

  const requestInitial = {
    dateFrom: now
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.DATE_FIXTURES)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>Create a fixture list for one selected calendar date.</ReportDescription>
          <ReportSection
            number={1}
            title="Report date"
            hint="Choose the day whose fixtures should appear in the report."
          >
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateFrom}
              onChangeFrom={date => setFieldValue('dateFrom', date)}
              onChangeTo={date => setFieldValue('dateFrom', date)}
            />
          </ReportSection>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
